var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 523.705,
    height: 398.45,
    viewBox: "0 0 523.705 398.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_order_confirmed_re_g0if",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M421.662,222.129h-1.911V169.792A30.292,30.292,0,0,0,389.46,139.5H278.576a30.292,30.292,0,0,0-30.292,30.292V456.92a30.292,30.292,0,0,0,30.292,30.292H389.46a30.292,30.292,0,0,0,30.292-30.292V259.384h1.911Z",
    transform: "translate(-212.102 -139.5)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M395.35,151.783H380.877a10.747,10.747,0,0,1-9.951,14.806H307.4a10.747,10.747,0,0,1-9.951-14.806H283.932A22.621,22.621,0,0,0,261.311,174.4V461.111a22.621,22.621,0,0,0,22.622,22.621H395.35a22.621,22.621,0,0,0,22.621-22.621h0V174.4a22.621,22.621,0,0,0-22.621-22.621Z",
    transform: "translate(-216.77 -143.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M436.993,680.783H192.534a.642.642,0,0,1,0-1.283H436.993a.642.642,0,1,1,0,1.283Z",
    transform: "translate(-191.892 -333.022)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 54.183,
    cy: 54.183,
    r: 54.183,
    transform: "translate(68.688 113.432)",
    fill: "#096f4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395-2",
    "data-name": "Path 395",
    d: "M364.752,409.93a5.619,5.619,0,0,1-3.381-1.124l-.06-.045-12.734-9.741a5.659,5.659,0,1,1,6.886-8.982l8.248,6.325,19.49-25.427a5.656,5.656,0,0,1,7.93-1.048h0l-.121.168.124-.168a5.663,5.663,0,0,1,1.046,7.932l-22.925,29.894a5.66,5.66,0,0,1-4.5,2.207Z",
    transform: "translate(-247.25 -221.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M884.587,652.19a16.851,16.851,0,0,1,2.314-2.948c.362-.376.744-.73,1.138-1.074a18.057,18.057,0,0,1,29.773,10.271c2.646-9.786-4.242-19.426-11.168-26.83s-14.849-15.522-14.809-25.664a19.538,19.538,0,0,1,6.948-14.411c.129-.113.257-.226.388-.335a26.352,26.352,0,0,1,18.15-6.325c12.319.66,23.075,8.939,30.544,18.76,12.023,15.8,17.292,37.982,8.875,55.97-7.4,15.82-23.194,25.215-39.309,32.767q-3.375,1.582-6.737,3.069c-.015,0-.031.014-.046.018-.108.047-.216.095-.317.144l-1.384.61.212.139.663.429-.687-.413c-.068-.042-.141-.082-.209-.124-7.915-4.749-15.94-9.773-21.408-17.188C881.847,671.355,879.567,660.328,884.587,652.19Z",
    transform: "translate(-439.142 -299.103)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M940.237,637.845a44.8,44.8,0,0,1,3.449,12.531,38.9,38.9,0,0,1-.469,11.557,49.84,49.84,0,0,1-9.995,21.381A71.732,71.732,0,0,1,920.273,695.9q-3.375,1.582-6.737,3.069c-.015,0-.031.014-.046.018-.108.047-.216.095-.317.144l-1.384.61.212.139.663.429-.687-.413c-.068-.042-.141-.082-.209-.124a39.3,39.3,0,0,0-22.026-47c.362-.376.744-.73,1.138-1.074a41.471,41.471,0,0,1,6.354,3.628,40.626,40.626,0,0,1,15.372,20.365,41.536,41.536,0,0,1,.9,23.219c.4-.26.8-.526,1.184-.792a72.83,72.83,0,0,0,19.288-18.268,46.365,46.365,0,0,0,8.227-20.907c.981-8.234-1.079-16.332-4.756-23.679a97.052,97.052,0,0,0-15.2-21.6,110.279,110.279,0,0,0-20.388-17.531.793.793,0,0,1-.235-1.067.674.674,0,0,1,.388-.335.587.587,0,0,1,.5.1c.924.617,1.84,1.239,2.745,1.879a111.53,111.53,0,0,1,20.381,18.617A89.791,89.791,0,0,1,940.237,637.845Z",
    transform: "translate(-441.984 -302.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-2",
    "data-name": "Ellipse 44",
    cx: 11.507,
    cy: 11.507,
    r: 11.507,
    transform: "translate(325.373 2.145)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-3",
    "data-name": "Ellipse 44",
    cx: 7.016,
    cy: 7.016,
    r: 7.016,
    transform: "translate(472.947 165.117)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-4",
    "data-name": "Ellipse 44",
    cx: 7.016,
    cy: 7.016,
    r: 7.016,
    transform: "translate(267.627 184.366)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M625.75,759.783H870.209a.642.642,0,1,0,0-1.283H625.75a.642.642,0,0,0,0,1.283Z",
    transform: "translate(-347.146 -361.334)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M943.9,230.151a9.4,9.4,0,0,0-18.053-4.765l-19.837,22.742,5.821,16.257,19.95-26.573a9.351,9.351,0,0,0,12.12-7.661Z",
    transform: "translate(-447.813 -168.147)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M630.7,187.41l65.849-70.277-8.882-14.121-82.592,69.85Z",
    transform: "translate(-216.844 -36.917)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 23.099,
    cy: 23.099,
    r: 23.099,
    transform: "translate(376.062 61.596)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M816.894,243.682a48.433,48.433,0,0,1,17.621-11.395c4.26-1.578,8.9-2.553,13.349-1.657s8.665,3.977,9.907,8.346c1.016,3.573-.033,7.42-1.61,10.783s-3.681,6.482-4.956,9.971a22.757,22.757,0,0,0,22.9,30.517c-4.375.587-8.409,2.643-12.686,3.737s-9.324,1.02-12.5-2.044c-3.363-3.242-3.43-8.512-3.268-13.181q.363-10.409.725-20.818c.123-3.539.229-7.191-1.048-10.494s-4.309-6.2-7.85-6.165c-2.684.023-5.059,1.649-7.211,3.252s-4.43,3.314-7.1,3.552-5.725-1.74-5.525-4.416Z",
    transform: "translate(-415.877 -172.036)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M670.612,490.929a9.4,9.4,0,0,1-7.083-17.276l19.955-22.639,16.878,3.646-23.738,23.251a9.35,9.35,0,0,1-6.011,13.017Z",
    transform: "translate(-359.182 -251.139)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M551.451,227.554l-49.736,62.43-15.16-6.96,58.459-91.011Z",
    transform: "translate(-174.369 -68.812)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M519.227,541.107l-11.853-.186,1.426,40.4h10.426Z",
    transform: "translate(-181.83 -193.852)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M703.1,738.081H682.571a13.086,13.086,0,0,0-13.085,13.084v.426H703.1Z",
    transform: "translate(-363.05 -354.016)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M640.933,524.511l-12.949,8.313,25.9,31.161,8.774-5.633Z",
    transform: "translate(-225.053 -187.971)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M861.528,710.049,844.25,721.142h0a13.086,13.086,0,0,0-3.941,18.08l.23.358,28.29-18.162Z",
    transform: "translate(-423.524 -343.97)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M790.616,417.621s-28.77-95.555-38.016-96.847-24.143,24.519-24.143,24.519c-19.315,24.644-39.232,104.47-39.232,104.47s33.2,2.078,57.473,14.991,52.913-.654,52.913-.654Z",
    transform: "translate(-370.124 -204.447)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M790.616,417.621s-28.77-95.555-38.016-96.847-20.359,24.78-20.359,24.78c-9.624,39.781-43.015,104.208-43.015,104.208s33.2,2.078,57.473,14.991,52.913-.654,52.913-.654Z",
    transform: "translate(-370.124 -204.447)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M576.568,283.961v48.016l5.651,69.555,28.232,52.613-13.474,9.624-38.5-50.047L543.252,364.03,519.34,474.036l-17.966-1.283,12.477-152.522L537.528,277.3Z",
    transform: "translate(-179.68 -99.377)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M759.158,342.615c-8.983,8.983-.642,18.607-.642,18.607l-10.266,23.1,40.422,10.908L802.8,332.107l-9.624-10.266c-19.249-.642-19.259-1.041-19.259-1.041C770.543,324.1,759.158,342.615,759.158,342.615Z",
    transform: "translate(-391.277 -204.473)",
    fill: "#096f4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M815.048,326.347a17.249,17.249,0,0,0-24.239,3.794c-10.162,14.149-19.558,37-6.612,65.492,20.788,45.754,38.878,69.176,46.232,69.174a2.925,2.925,0,0,0,.945-.148c4.527-1.536,11.072-9.2,12.257-15.946.424-2.416.323-5.782-2.566-8.092-8.3-6.638-23.2-27.309-27.848-54.515-2.569-15.033,2.413-28.727,7.044-37.567a17.246,17.246,0,0,0-4.99-22.026h0Z",
    transform: "translate(-401.899 -205.253)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 17.003,
    cy: 17.003,
    r: 17.003,
    transform: "translate(369.115 83.84) rotate(-28.663)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M765.872,268.267h24.552l.252-3.525,1.259,3.525h3.781l.5-6.986,2.495,6.986h7.315v-.346a18.366,18.366,0,0,0-18.345-18.345h-3.462a18.366,18.366,0,0,0-18.345,18.346Z",
    transform: "translate(-397.592 -178.948)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M817.469,282.344l10.478-3.4V253.5h-19.79l.49.489C815.463,260.8,823.044,284.952,817.469,282.344Z",
    transform: "translate(-412.745 -180.355)",
    fill: "#2f2e41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingSuccess);
export default __webpack_public_path__ + "static/media/onboarding-success.ee69a5779c3a6523bfefb745d5cd87d2.svg";
export { ForwardRef as ReactComponent };